// Inactivity bookkeeping shared by every open tab through localStorage, so
// activity in one tab keeps the session alive in the others.

// Fixed for now; becomes a user preference in a follow-up task.
// Keep in sync with SESSION_IDLE_TIMEOUT in Admincat/settings/base.py.
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;

// While the user is active, refresh the token at most this often so the
// server-side session slides forward even when the UI makes no API calls.
// Keep in sync with SESSION_TOKEN_KEEPALIVE in Admincat/settings/base.py.
export const TOKEN_KEEPALIVE_MS = 5 * 60 * 1000;

const LAST_ACTIVITY_KEY = 'lastActivityAt';
const TOKEN_REFRESHED_KEY = 'tokenRefreshedAt';

const writeTimestamp = (key, value) => {
  try {
    localStorage.setItem(key, String(value));
  } catch (e) {
    // Storage unavailable (private mode, quota); the timer just won't persist.
  }
};

const readTimestamp = (key) => {
  try {
    const value = Number(localStorage.getItem(key));
    return value > 0 ? value : null;
  } catch (e) {
    return null;
  }
};

export const markActivity = (now = Date.now()) => writeTimestamp(LAST_ACTIVITY_KEY, now);

export const getLastActivity = () => readTimestamp(LAST_ACTIVITY_KEY);

export const markTokenRefreshed = (now = Date.now()) =>
  writeTimestamp(TOKEN_REFRESHED_KEY, now);

export const getTokenRefreshedAt = () => readTimestamp(TOKEN_REFRESHED_KEY);

// A fresh login: the user is active and the tokens are brand new.
export const startSessionClock = (now = Date.now()) => {
  markActivity(now);
  markTokenRefreshed(now);
};

export const clearActivity = () => {
  try {
    localStorage.removeItem(LAST_ACTIVITY_KEY);
    localStorage.removeItem(TOKEN_REFRESHED_KEY);
  } catch (e) {
    // Nothing to clear.
  }
};

export const getRemainingMs = (now = Date.now()) => {
  const lastActivity = getLastActivity();
  if (lastActivity === null) return IDLE_TIMEOUT_MS;
  return Math.max(0, IDLE_TIMEOUT_MS - (now - lastActivity));
};

export const isLoggedIn = () => Boolean(localStorage.getItem('token'));
